import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Cookies } from "react-cookie";
import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";

export const dashboardPresidentCount = createAsyncThunk(
  "dashboardPresidentCount",
  async () => {
    try {
      const cookies = new Cookies();
      const token = cookies.get("token");

      const response = await AxiosInstance.get(
        `${API_KEY}/api/dashboard/president-counts`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data.message;
      } else {
        throw error;
      }
    }
  }
);
const initialState = {
  isLoading: false,
  dashboardPresidentCountData: null,
  isError: false,
  errorMessage: "",
};

const dashboardPresidentCountSlice = createSlice({
  name: "dashboardPresidentCount",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(dashboardPresidentCount.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(dashboardPresidentCount.fulfilled, (state, action) => {
      state.isLoading = false;
      state.dashboardPresidentCountData = action.payload;
    });
    builder.addCase(dashboardPresidentCount.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default dashboardPresidentCountSlice.reducer;